'use client'

import { motion } from 'framer-motion'

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
}

const checkItems = [
  'Have a busy schedule or find it difficult to travel to appointments.',
  'Live in a remote area with limited access to psychiatric specialists.',
  'Have mobility issues or physical health conditions that make travel challenging.',
  'Feel more comfortable receiving care in your own private environment.',
  'Have reliable internet access and a private space for sessions.',
]

const CheckItem: React.FC<{ text: string }> = ({ text }) => (
  <li className="flex items-start gap-3">
    <div className="shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-emerald-500 flex items-center justify-center mt-0.5">
      <svg
        className="w-3 h-3 sm:w-4 sm:h-4 text-white"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <p className="text-sm sm:text-base text-gray-700">{text}</p>
  </li>
)

const IsItRightForYou: React.FC = () => (
  <section className="py-12 sm:py-16 lg:py-20 px-4 bg-gray-50">
    <div className="max-w-7xl mx-auto">
      <motion.div
        className="max-w-3xl mx-auto"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={fadeIn}
      >
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif text-gray-900 mb-6 sm:mb-8 text-center">
          Is Online Psychiatry Right for You?
        </h2>
        <p className="text-base sm:text-lg text-gray-700 mb-8 sm:mb-12 leading-relaxed">
          Online psychiatry is an excellent option for many individuals, but
          it's important to consider if it's the best fit for your specific
          situation. Telehealth may be ideal if you:
        </p>

        <ul className="space-y-4">
          {checkItems.map((item) => (
            <CheckItem key={item} text={item} />
          ))}
        </ul>

        <p className="text-sm sm:text-base text-gray-700 mt-6 sm:mt-8 italic leading-relaxed">
          While highly effective, online psychiatry may not be suitable for all
          individuals or every situation, particularly in cases of severe crisis
          requiring immediate in-person intervention. Our team can help
          determine if telehealth is appropriate for you during an initial
          consultation.
        </p>
      </motion.div>
    </div>
  </section>
)

export default IsItRightForYou
